import type { OfferPreset } from "../../types"

import hero from "@/features/offers/assets/soulmate/hero.webp"
import feature1 from "@/features/offers/assets/soulmate/feature-1.svg"
import feature2 from "@/features/offers/assets/soulmate/feature-2.svg"
import feature3 from "@/features/offers/assets/soulmate/feature-3.svg"
import gift from "@/features/offers/assets/soulmate/gift.webp"
import card1 from "@/features/offers/assets/soulmate/card-1.webp"
import card2 from "@/features/offers/assets/soulmate/card-2.webp"
import chipZodiac from "@/features/offers/assets/soulmate/chip-zodiac.svg"
import chipLoveEnergy from "@/features/offers/assets/soulmate/chip-loveenergy.svg"
import reviewer10 from "@/features/offers/assets/soulmate/reviewer-10.webp"
import reviewer11 from "@/features/offers/assets/soulmate/reviewer-11.webp"
import reviewer12 from "@/features/offers/assets/soulmate/reviewer-12.webp"

export const soulmatePreset: OfferPreset = {
  key: "soulmate",
  stepLabel: "Sketch",
  unlockedLabel: "Exclusive Soulmate Sketch unlocked",
  hero: {
    title: "Reveal Your Soulmate Sketch",
    subtitle:
      "See a personalized pencil portrait of your future partner and uncover the traits, signs, and connection patterns behind your match",
    bg: hero,
    fullBleed: false,
  },
  benefits: [
    {
      icon: feature1,
      title: "Personal Sketch Reveal",
      subtitle: "View a pencil portrait of the person highlighted in your soulmate report",
    },
    {
      icon: feature2,
      title: "Love & Personality Traits",
      subtitle: "Discover their thoughts, love, connections, and emotional presence",
    },
    {
      icon: feature3,
      title: "Meeting Signs & Timing",
      subtitle: "Look for clues about when and where your paths might cross and what signs to watch for",
    },
  ],
  gift: {
    title: "Compatibility Snapshot",
    subtitle: "Preview your zodiac match score and why your signs may feel connected",
    image: gift,
    strikePrice: "$19.99",
  },
  price: {
    heading: "Your Soulmate Sketch Awaits",
    reportLabel: "Soulmate Sketch Report",
    giftLabel: "Compatibility Snapshot",
  },
  ctaLabel: "Unlock Soulmate Sketch",
  featureCards: {
    heading: "Why This Sketch Feels Personal",
    cards: [
      {
        image: card1,
        title: "More Than Just a Portrait",
        subtitle:
          "Go beyond the face and explore their personality, emotional style, meeting clues, and the first signs behind your soulmate connection.",
        chips: [],
      },
      {
        image: card2,
        title: "Shaped by Your Zodiac Match",
        subtitle:
          "Your sketch is paired with zodiac insights to explain why this person may feel familiar, what creates attraction, and where the connection needs care.",
        chips: [
          { icon: chipZodiac, label: "Zodiac Match" },
          { icon: chipLoveEnergy, label: "Love Energy" },
        ],
      },
    ],
  },
  reviews: {
    heading: "What users say after unlocking their sketch",
    items: [
      {
        avatar: reviewer10,
        name: "Emma Reed",
        rating: "4.9",
        text: "I didn’t expect the sketch to feel so personal. The face, the energy, even the expression felt strangely close to someone I could actually meet.",
      },
      {
        avatar: reviewer11,
        name: "Daniel Brooks",
        rating: "4.8",
        text: "I liked that it wasn’t just a drawing. The report explained the match, the emotional dynamic, and where this kind of connection might appear.",
      },
      {
        avatar: reviewer12,
        name: "Sophie Grant",
        rating: "5.0",
        text: "The portrait was what got my attention, but the personality details made it feel real. It described the kind of person I’m always drawn to.",
      },
    ],
  },
}
